/*eslint-disable */
var $ = window.jQuery = require('jquery');
export default {
  name: 'user-left-room',
  components: {},
  props: [],
  data () {
    return {
      hasGetFromRoute:''
    }
  },
  computed: {

  },
  mounted () {
    this.hasGetFromRoute = this.$route.hash
  },
  methods: {

  },
  beforeCreate: function() {
    $('body').addClass('sidebar_collapsed')
  },
  beforeRouteLeave: function(to, from, next) {
    if(to.name != 'videoChatOneToOnePeer'){
      $('body').removeClass('sidebar_collapsed')
    }
    next();
  },
}


